/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgStoppedRunning32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path fill='currentColor' d='M13.75 15.5h-4V14h4v1.5z' />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M.25 16C.25 7.302 7.302.25 16 .25S31.75 7.302 31.75 16 24.698 31.75 16 31.75.25 24.698.25 16zM16 1.75C8.13 1.75 1.75 8.13 1.75 16c0 3.665 1.384 7.007 3.657 9.532L7.44 23.5 6 22.06V17H4.5v2.75H3v-7h1.5v2.75H6V10h2.349l2-3h7.802l2 3h.788l4.593-4.593A14.197 14.197 0 0016 1.75zm10.593 4.718L22.5 10.56V13h1.604a2.751 2.751 0 012.646-2h1.75v10.5h-1.75a2.751 2.751 0 01-2.646-2H22.5v2.56l-3.44 3.44H9.44l-.94-.94-2.032 2.033A14.197 14.197 0 0016 30.25c7.87 0 14.25-6.38 14.25-14.25 0-3.665-1.384-7.007-3.657-9.532zM9.56 23.5l.5.5h8.378l1.5-1.5h-9.378l-1 1zm2.5-2.5H21v-8.94L16.06 17h1.69v1.5h-3.19l-2.5 2.5zm1.878-4H9.75v1.5h2.69L9.94 21H7.5v-9.5h11.94l-5.5 5.5zm4.41-7l-1-1.5H11.15l-1 1.5h8.198zm4.151 4.5H24V18h-1.5v-3.5zm4.25-2c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25H27v-7.5h-.25z'
      />
    </svg>
  );
}

export default SvgStoppedRunning32;
